module.exports = __webpack_public_path__ + "img/164w.ecc64f7.jpg";